module.exports = __webpack_public_path__ + "static/media/ophthalmology-banner.9be9ddb6.png";